/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Club_TwoInputs */

const en_platform_team_club_two = /** @type {(inputs: Platform_Team_Club_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients pick the coach and the time`)
};

const pl_platform_team_club_two = /** @type {(inputs: Platform_Team_Club_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podopieczny wybiera trenera i godzinę`)
};

/**
* | output |
* | --- |
* | "Clients pick the coach and the time" |
*
* @param {Platform_Team_Club_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_club_two = /** @type {((inputs?: Platform_Team_Club_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Club_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_club_two(inputs)
	return en_platform_team_club_two(inputs)
});